<template>
  <v-dialog v-model="dialog" persistent max-width="600">
    <v-btn flat dark small class="primary" slot="activator">
      <v-icon>edit</v-icon>
    </v-btn>
    <v-card>
      <v-card-title>
        <h2>Modifica Tipo Corso</h2>
      </v-card-title>
      <v-card-text>
        <v-form ref="form">
          <!-- Nome Tipo Corso -->

          <v-layout row wrap>
            <v-flex xs12 sm8 md6 offset-sm2 offset-md3>
              <v-text-field v-model="name" :rules="nameRules" label="Nome Tipo Corso" required></v-text-field>
            </v-flex>
          </v-layout>

          <!-- Descrizione Svolgimento Corso -->

          <v-layout row wrap>
            <v-flex xs12 sm8 md6 offset-sm2 offset-md3>
              <v-textarea
                v-model="description"
                :rules="descriptionRules"
                label="Descrizione Tipo Corso"
                required
              ></v-textarea>
            </v-flex>
          </v-layout>

          <v-layout row wrap>
            <v-flex xs12 sm8 md6 mt-5 offset-sm2 offset-md3>
              <v-btn color="success" @click="onCreate()" :loading="loading">Conferma</v-btn>
              <v-btn color="error" @click="closeDialog()">Annulla</v-btn>
            </v-flex>
          </v-layout>
        </v-form>
      </v-card-text>
    </v-card>
  </v-dialog>
</template>

<script>
import { bus } from "../main";
import { db } from "../main";
export default {
  props: ["courseType"],
  data: () => ({
    dialog: false,
    valid: true,
    name: "",
    nameRules: [
      v => !!v || "Nome Tipo Corso necessario",
      v =>
        (v && v.length <= 50) ||
        "Il Nome del Tipo corso deve essere minore di 50 caratteri"
    ],
    descriptionRules: [
      v => !!v || "Descrizione svolgimento corso necessaria",
      v =>
        (v && v.length <= 200) ||
        "La Descrizione del Tipo corso deve essere minore di 200 caratteri"
    ],
    description: "",
    loading: false
  }),

  methods: {
    validate() {
      if (this.$refs.form.validate()) {
        this.snackbar = true;
      }
    },
    onCreate() {
      if (this.$refs.form.validate()) {
        this.loading = true;
        const courseType = {
          nome: this.name,
          descrizione: this.description
        };
        db.collection("tipi_corso")
          .doc(this.courseType)
          .set(courseType)
          .then(() => {
            bus.$emit(
              "successfullOperation",
              "Tipo Corso modificato con successo"
            );

            this.loading = false;

            this.dialog = false;
          })
          .catch(error => {
            this.loading = false;
            bus.$emit("errorOperation", "Errore: problema nella modifica del tipo corso(" + error + ")");
          });
      }
    },
    closeDialog() {
      this.dialog = false;
      this.loading = false;
    },
    compileFields() {
      db.collection("tipi_corso")
        .doc(this.courseType)
        .get()
        .then(doc => {
          this.name = doc.data().nome;
          this.description = doc.data().descrizione;
        })
        .catch(error => {
          bus.$emit("errorOperation", "Errore: problema nel recupero delle informazioni sul tipo corso(" + error + ")");
        });
    }
  },
  created() {
    this.compileFields();
  }
};
</script>

<style>
</style>
